import useUser from '@/hooks/useUser';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { isMarketSupported } from '@/utilities/markets';

const QUERY = gql(`
  query companyPredefinedScreeners(
    $limit: Int!
    $offset: Int!
    $additionalFilters: [AdditionalScreenerFilter!]
  ) {
    companyPredefinedScreeners(
      input: {
        limit: $limit
        offset: $offset
        additionalFilters: $additionalFilters
      }
    ) {
      id
      name
      slug
      resultPreview {
        newCompaniesTotalHits
      }
    }
  }
`);

export const usePredefinedScreeners = () => {
  // Determine market the same way as 'Discover' (Investing ideas) does
  const { data: user } = useUser();
  const market = user.defaultMarketISO || user.countryISO;

  const result = makeGqlSuspenseQuery(QUERY)({
    additionalFilters: isMarketSupported(market)
      ? [
          {
            values: [market],
            logicalCondition: 'aor',
            operator: 'in',
            field: 'country_name',
          },
        ]
      : [],
    offset: 0,
    limit: 6,
  });

  return result;
};
